export const Login = {
    email: '',
    password: ''
}